import { INGXLoggerConfig } from 'ngx-logger';
import {environment} from '../../../environments/environment';

export const LOGGER_CONFIG: INGXLoggerConfig = {
    // TODO: uncomment when path available
  // serverLoggingUrl: `${environment.apiUrl}/logs`,
  // httpResponseType: 'json',
  level: environment.browserLogLevel,
  serverLogLevel: environment.serverLogLevel,
  disableConsoleLogging: environment.disableConsoleLogging, // disabled in prod
  timestampFormat: 'full'
};
